import styled from 'styled-components';

export default function ProductPlaceholder({ className }) {
    return (
        <Wrapper className={className}>
            <div className="placeholder slider mb-32" />
            <div className="text">
                <div
                    className="placeholder mb-12"
                    style={{ width: '80%', height: '50px' }}
                />
                <div
                    className="placeholder mb-48"
                    style={{ width: '50%', height: '20px' }}
                />

                <div
                    className="placeholder mb-12"
                    style={{ width: '70%', height: '30px' }}
                />
                <div
                    className="placeholder mb-12"
                    style={{ width: '40%', height: '30px' }}
                />
                <div
                    className="placeholder mb-12"
                    style={{ width: '60%', height: '30px' }}
                />
                <div
                    className="placeholder mb-12"
                    style={{ width: '80%', height: '30px' }}
                />
                <div
                    className="placeholder mb-12"
                    style={{ width: '60%', height: '30px' }}
                />
                <div
                    className="placeholder mb-12"
                    style={{ width: '30%', height: '30px' }}
                />
            </div>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    overflow: hidden;
    .placeholder {
        border-radius: 12px;
        position: relative;
        background: #f0f0f4;
        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            bottom: 0;
            background: linear-gradient(
                90deg,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0.8) 50%,
                rgba(255, 255, 255, 0) 100%
            );
            display: block;
            transform: translateX(-75%);
            animation: shine 1.5s ease-in-out 0s infinite;
        }
        @keyframes shine {
            0% {
                transform: translateX(-75%);
            }
            100% {
                transform: translateX(175%);
            }
        }
        &.slider {
            padding-top: 55.92%;
        }
    }
    .text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
`;
